import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Fuse from 'fuse.js';
import { HiSearch } from 'react-icons/hi';
import foodTopics from '../../data/health/foodTopics';

const FoodSearchBox = () => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const fuse = useMemo(
    () =>
      new Fuse(foodTopics, {
        keys: [
          { name: 'title', weight: 2 },
          { name: 'synonyms', weight: 1.5 },
          { name: 'whatItIs', weight: 0.5 },
        ],
        threshold: 0.35,
        includeMatches: true,
        minMatchCharLength: 2,
      }),
    []
  );

  const results = query.length >= 2 ? fuse.search(query).slice(0, 8) : [];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="health-search-wrapper" ref={wrapperRef}>
      <HiSearch className="health-search-icon" size={18} />
      <input
        type="text"
        className="health-search-input"
        placeholder="Search topics — protein, vitamin C, belly fat..."
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setIsOpen(true);
        }}
        onFocus={() => query.length >= 2 && setIsOpen(true)}
        autoComplete="off"
      />

      {isOpen && results.length > 0 && (
        <div className="health-search-results">
          {results.map(({ item }) => (
            <Link
              key={item.slug}
              to={`/health/food/${item.slug}`}
              className="health-search-result-item"
              onClick={() => {
                setIsOpen(false);
                setQuery('');
              }}
            >
              <div style={{ fontWeight: 600, color: 'var(--color-text-primary)', marginBottom: '0.125rem' }}>
                {item.title}
              </div>
              <div style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
                {item.whatItIs.length > 80
                  ? item.whatItIs.substring(0, 80) + '...'
                  : item.whatItIs}
              </div>
            </Link>
          ))}
        </div>
      )}

      {isOpen && query.length >= 2 && results.length === 0 && (
        <div className="health-search-results">
          <div className="health-search-result-item" style={{ color: 'var(--color-text-muted)' }}>
            No topics found for "{query}"
          </div>
        </div>
      )}
    </div>
  );
};

export default FoodSearchBox;
